import { CsiImage, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import imageLT from "./LandscapeThumbnail.jpg";
import imagePT from "./PortraitThumbnail.jpg";

export default () => {
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="landscape" />
			<Text semiBold text="portrait" />
			<CsiImage borderRadius={5} src={imageLT} />
			<CsiImage borderRadius={5} src={imagePT} />
		</CssColumnGrid>
	);
};